import $ from 'jquery';
import { AJAX_URL } from './config';

let dob_roles = $('#sports-nutrition-form').data('dob-roles');
let school_roles = $('#sports-nutrition-form').data('school-roles');

// explode the roles into arrays
dob_roles = dob_roles ? dob_roles.split(',') : [];
school_roles = school_roles ? school_roles.split(',') : [];

// After page load, check if form exists
$(document).ready(function () {
  // If it does, add the recaptcha
  if ($('#sports-nutrition-form').length) {
    // Attempt to read the HubSpot tracking cookie
    const hubspotCookie = document.cookie
      .split('; ')
      .find((row) => row.startsWith('hubspotutk='))
      ?.split('=')[1];

    // If found, attach it as a hidden input field
    if (hubspotCookie) {
      const form = document.getElementById('sports-nutrition-form');
      const hidden = document.createElement('input');
      hidden.type = 'hidden';
      hidden.name = 'hubspotutk';
      hidden.id = 'hubspotutk';
      hidden.value = hubspotCookie;
      form.appendChild(hidden);
    }
  }
});

// Catch when register form is submitted
$('#sports-nutrition-form').on('submit', function (e) {
  // Prevent default
  e.preventDefault();
  $('.login__submit').hide();
  $('.submit__loading').show();

  // Get form data
  let position = [];
  $.each($('input[name="position[]"]:checked'), function () {
    position.push($(this).val());
  });
  const data = {
    first_name: $('[name="first_name"]').val(),
    last_name: $('[name="last_name"]').val(),
    email: $('[name="email"]').val(),
    password: $('[name="password"]').val(),
    confirm_password: $('[name="confirm_password"]').val(),
    school: $('[name="school"]').val(),
    non_texas_school: $('[name="non_texas_school"]').val(),
    city: $('[name="city"]').val(),
    state: $('[name="state"]').val(),
    isd: $('[name="isd"]').val(),
    date_of_birth: $('[name="date_of_birth"]').val(),
    position: position,
    position_other: $('[name="position_other"]').val(),
    grade_level: $('[name="grade_level"]').val(),
    grade_level_other: $('[name="grade_level_other"]').val(),
    question: $('[name="question"]').val(),
    phone: $('[name="phone"]').val(),
    opt_out: $('[name="opt_out"]').val(),
    redirect_to: $('[name="redirect_to"]').val(),
    hubspotutk: $('#hubspotutk').val() || ''
  };

  $.ajax({
    url: `${AJAX_URL}wl_post_sports_register_form`,
    data: data,
    type: 'POST',
    dataType: 'json',
    encode: true,
    contentType: 'application/x-www-form-urlencoded; charset=UTF-8'
  })
    .then(({ success, data }) => {
      $('.login__submit').show();
      $('.submit__loading').hide();

      // scroll to div with class .login__title
      $('html, body').animate(
        { scrollTop: $('.login__title').offset().top },
        1000
      );
      if (!success) {
        $.each(data.errors, function (key, value) {
          $('#' + key)
            .parent()
            .append(
              '<small class="form__help u--color-red">' + value + '</small>'
            );
        });
        $('#notice').html(data.notice);
        return;
      } else {
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
          event: 'registration',
          event_type: 'sngp'
        });
        // $('#notice').html(data.notice);
        // Redirect the user
        if (data.redirect) {
          window.location.href = data.redirect;
        }
      }
    })
    .catch((err) => console.log(err.message));
});

// Change value of school zip after school select is changed
if ($('select[name="school"]').length) {
  $('select[name="school"]').on('change', function () {
    // Get school name
    const schoolName = $('select[name="school"]').val();

    // Get school zip by school name
    $.ajax({
      url: `${AJAX_URL}wl_get_zip_code_by_school`,
      data: { school_name: schoolName },
      type: 'POST',
      dataType: 'json',
      encode: true,
      contentType: 'application/x-www-form-urlencoded; charset=UTF-8'
    })
      .then(({ success, data }) => {
        if (success) {
          const schoolZip = data.zipCode;
          // Set the school zip input value
          const schoolZipInput = $('input[name="school_zip"]');
          schoolZipInput.val(schoolZip);
          // Trigger change event to update ISD select
          schoolZipInput.trigger('change');
        } else {
          console.error('Failed to fetch school zip:', data.error);
        }
      })
      .catch((err) => console.log(err.message));
  });
}

// If ISD select exists, add change event listener
if ($('select[name="isd"]').length) {
  $('select[name="isd"]').on('change', function () {
    // Get schools by ISD
    const isd = this.value;
    $.ajax({
      url: `${AJAX_URL}wl_get_schools_by_district`,
      data: { isd: isd },
      type: 'POST',
      dataType: 'json',
      encode: true,
      contentType: 'application/x-www-form-urlencoded; charset=UTF-8'
    })
      .then(({ success, data }) => {
        if (success) {
          const schools = data.schools;
          const schoolSelect = $('select[name="school"]');
          schoolSelect.empty();
          schoolSelect.append('<option value="">Select a School</option>');
          $.each(schools, function (index, school) {
            schoolSelect.append(
              `<option value="${school.school_name}">${school.school_name}</option>`
            );
          });
        } else {
          console.error('Failed to fetch schools:', data.error);
        }
      })
      .catch((err) => console.log(err.message));
  });
}

if ($('select[name="grade_level"]').length) {
  $('select[name="grade_level"]').on('change', function () {
    if (this.value === 'Other') {
      $('.grade_level_other_container').removeClass('u--display-none');
    } else {
      $('.grade_level_other_container').addClass('u--display-none');
    }
  });
}

if ($('input[name="position[]"]').length) {
  $('input[name="position[]"]').on('change', function () {
    // Get form data
    let position = [];
    $.each($('input[name="position[]"]:checked'), function () {
      position.push($(this).val());
    });

    if (position.includes('Other')) {
      $('.position_other_container').removeClass('u--display-none');
    } else {
      $('.position_other_container').addClass('u--display-none');
    }

    // Check if DOB is shown
    // Do any roles in dob_roles overlap with position?
    if (dob_roles.some((role) => position.includes(role))) {
      $('.date_of_birth_container').removeClass('u--display-none');
    } else {
      $('.date_of_birth_container').addClass('u--display-none');
    }

    // Check if School is shown
    // Do any roles in school_roles overlap with position?
    if (school_roles.some((role) => position.includes(role))) {
      let state = $('select[name="state"]').val();
      if (state && state == 'Texas') {
        $('.school_district_container').removeClass('u--display-none');
        $('.school_container').removeClass('u--display-none');
        $('.non_school_container').addClass('u--display-none');
      } else {
        $('.non_school_container').removeClass('u--display-none');
        $('.school_district_container').addClass('u--display-none');
        $('.school_container').addClass('u--display-none');
      }
    } else {
      $('.school_district_container').addClass('u--display-none');
      $('.school_container').addClass('u--display-none');
    }
  });
}

// If state select exists, add change event listener
if ($('select[name="state"]').length) {
  $('select[name="state"]').on('change', function () {
    let position = [];
    $.each($('input[name="position[]"]:checked'), function () {
      position.push($(this).val());
    });

    if (school_roles.some((role) => position.includes(role))) {
      if (this.value && this.value == 'Texas') {
        $('.school_district_container').removeClass('u--display-none');
        $('.school_container').removeClass('u--display-none');
        $('.non_school_container').addClass('u--display-none');
      } else {
        $('.non_school_container').removeClass('u--display-none');
        $('.school_district_container').addClass('u--display-none');
        $('.school_container').addClass('u--display-none');
      }
    } else {
      $('.school_district_container').addClass('u--display-none');
      $('.school_container').addClass('u--display-none');
      $('.non_school_container').addClass('u--display-none');
    }
  });
}
